<template>
  <div :class="wrpCls">
    <a-space size="middle">
      <a-tooltip placement="bottom">
        <template slot="title">
          平臺客服
        </template>
        <a-icon type="github" @click="loginKf" :style="{ fontSize: '20px' }"/>
      </a-tooltip>
<!--      <a-tooltip placement="bottom">
        <template slot="title">
          文档地址
        </template>
        <a-icon type="question-circle-o" @click="toDoc" :style="{ fontSize: '20px' }"/>
      </a-tooltip>-->
      <screenfull />
      <notice-icon v-hasPermi="['system:notice:list']" style="cursor: pointer;"/>
      <avatar-dropdown :menu="showMenu" :current-user="currentUser" :class="prefixCls" />
      <!-- 暂只支持中文，国际化可自行扩展 -->
      <!-- <select-lang :class="prefixCls" /> -->
    </a-space>
  </div>
</template>

<script>
import AvatarDropdown from './AvatarDropdown'
import NoticeIcon from '@/components/NoticeIcon'
import Screenfull from '@/components/Screenfull'
import SelectLang from '@/components/SelectLang'
import request from "@/utils/request";

export default {
  name: 'RightContent',
  components: {
    AvatarDropdown,
    NoticeIcon,
    Screenfull,
    SelectLang
  },
  props: {
    prefixCls: {
      type: String,
      default: 'ant-pro-global-header-index-action'
    },
    isMobile: {
      type: Boolean,
      default: () => false
    },
    topMenu: {
      type: Boolean,
      required: true
    },
    theme: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      roleId: null,
      showMenu: true,
      currentUser: {},
      docUrl: process.env.VUE_APP_BASE_API +'/doc',
      githubUrl: 'http://gitlab.niurenjianzhan.com/zhangxun/java-framework'
    }
  },
  computed: {
    wrpCls () {
      return {
        'ant-pro-global-header-index-right': true,
        [`ant-pro-global-header-index-${(this.isMobile || !this.topMenu) ? 'light' : this.theme}`]: true
      }
    }
  },
  mounted () {
    setTimeout(() => {
      this.getRole();
      this.currentUser = {
        name: 'RuoYi'
      }
    }, 1500)
  },
  methods: {
    toDoc () {
      window.open(this.docUrl)
    },
    getRole(){
      let that = this;
      request({
        url: '/system/user/getRole',
        method: 'post'
      }).then(response => {
        that.roleId = response.data;
      })
    },
    loginKf() {

      request({
        url: '/system/config/getValue?configGroup=platform&configKey=callCenterId',
        method: 'get'
      }).then(response => {
        let id = response.data;
        let name = "刷手客服";
        let avatar = "https://shuashou110.oss-cn-beijing.aliyuncs.com/default/cover.png";
        // var token = JSON.parse(this.getLocalItem("pro__Access-Token")).value;
        window.open('https://admin.shushou.com.tw/tencentkf?id='+id+"&avatar="+avatar+"&name="+name, 'kfWidow',"444");
      })
    },
    getLocalItem (name) {
      const value = localStorage.getItem(name);
      if (value) {
        return value;
      } else {
        return '';
      }
    },
    toGithub () {
      window.open(this.githubUrl)
    }
  }
}
</script>
